import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Dispatch } from "react";

import { Microservices } from "../../../../app/AllowedMicroservices";
import { RootState } from "../../../../app/store";
import apiActionCreator, {
  HttpMethods,
} from "../../../../services/apiActionCreator";
import { FetchStatus } from "../../../common/enums";

interface IProgressPerUserResponse {
  [userId: string]: {
    [courseId: string]: number, // percentage of completion
  }
}
interface IProgressPerUserState {
  data: IProgressPerUserResponse | null,
  status: FetchStatus,
}
const initialState: IProgressPerUserState = {
  data: null,
  status: FetchStatus.Idle,
};

export const dataSlice = createSlice({
  name: "reportLearningCoursesProgressPerUser",
  initialState,
  reducers: {
    fetching: (state) => {
      state.status = FetchStatus.Fetching;
    },
    fetched: (state, action: PayloadAction<IProgressPerUserResponse>) => {
      state.status = FetchStatus.Fetched;
      state.data = action.payload;
    },
    error: (state) => {
      state.status = FetchStatus.Error;
    },
  },
});

export const { fetching, fetched, error } = dataSlice.actions;

export const fetchProgressPerUser = (usersIds: string[]) => (dispatch: Dispatch<object>) => {
  let url = '/stats/progressPerUser';
  return dispatch(apiActionCreator({
    endpoint: url,
    types: {
      requestType: fetching,
      successTypes: [
        {
          actionOrCreator: fetched,
        },
      ],
      errorTypes: [
        {
          actionOrCreator: error,
        },
      ],
    },
    method: HttpMethods.POST,
    microservice: Microservices.LEARNING_SERVICE,
    authenticated: true,
    data: {
      usersIds,
    },
  }));
};

export const selectCoursesProgressPerUser = (state: RootState) => state.reports.learning.courses.progressPerUser.data;
export const selectCoursesProgressPerUserFetching = (state: RootState) => state.reports.learning.courses.progressPerUser.status === FetchStatus.Fetching;

export default dataSlice.reducer;
